import React, { useEffect } from 'react'
import { Box, Stack } from '@mui/material'
import { useSessionContext } from 'session'
import { NewOrganizationInfoBlock } from 'components'
export const OrganizationAddPage: React.FC = () => {
  const { changeModuleName } = useSessionContext()

  useEffect(() => {
    changeModuleName('New Organization')
  }, [changeModuleName])

  return (
                <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mt: 1
                    }}
                >
                    <Stack spacing={2} alignItems="center" mt={1} width="98%">
                        <NewOrganizationInfoBlock/>
                    </Stack>
                </Box>
  )
}
